import React from 'react';
import { useDispatch } from 'react-redux';
import { Breadcrumb, Card, Form, Input, Button, message, Typography, Select } from 'antd';

const { Option } = Select;
import { Link, useNavigate } from 'react-router-dom';
import * as Icon from 'react-feather';
import {
  curatedContentActionStarts,
  curatedContentActionErrors,
  createCuratedContentAction,
} from '../../core/data/redux/modules/curatedContent/actions';
import { createCuratedContent } from '../../services/curatedContentServices';

const { Title } = Typography;
const { TextArea } = Input;

const CreateCuratedContent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    dispatch(curatedContentActionStarts());
    try {
      const contentData = {
        ...values,
        publish_status: values.publish_status || 'DRAFT',
      };
      
      const res = await createCuratedContent(contentData);
      if (res.error === true) throw new Error(res.message || 'Error creating curated content');
      
      dispatch(createCuratedContentAction(res.data));
      message.success('Curated content created successfully');
      navigate('/admin/curated-content');
    } catch (err: any) {
      dispatch(curatedContentActionErrors(err.message));
      message.error(err.message);
    }
  };

  return (
    <div className="page-wrapper page-settings" style={{ paddingTop: 0 }}>
      <div className="content">
        <Breadcrumb style={{ marginBottom: 20 }}>
          <Breadcrumb.Item>
            <Link to="/admin/curated-content">Curated Content</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Create Curated Content</Breadcrumb.Item>
        </Breadcrumb>
        
        <Card>
          <Title level={4} style={{ marginBottom: 24 }}>Create New Curated Content</Title>
          
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              publish_status: 'DRAFT',
            }}
          >
            <Form.Item
              label="Content"
              name="content"
              rules={[{ required: true, message: 'Please enter content' }]}
            >
              <TextArea rows={6} placeholder="Enter curated content..." />
            </Form.Item>

            <Form.Item
              label="Type"
              name="type"
              rules={[{ required: true, message: 'Please select content type' }]}
            >
              <Select>
                <Option value="TEXT">Text</Option>
                <Option value="IMAGE">Image</Option>
                <Option value="VIDEO">Video</Option>
                <Option value="LINK">Link</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Publish Status"
              name="publish_status"
            >
              <Select>
                <Option value="DRAFT">Draft</Option>
                <Option value="PUBLISHED">Published</Option>
                <Option value="ARCHIVED">Archived</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Image URL (Optional)"
              name="image_url"
            >
              <Input placeholder="Enter image URL" />
            </Form.Item>

            <Form.Item
              label="Link URL (Optional)"
              name="link_url"
            >
              <Input placeholder="Enter link URL" />
            </Form.Item>

            <Form.Item>
              <div style={{ display: 'flex', gap: 8 }}>
                <Button type="primary" htmlType="submit" icon={<Icon.Save size={16} />}>
                  Create Curated Content
                </Button>
                <Button onClick={() => navigate('/admin/curated-content')}>
                  Cancel
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default CreateCuratedContent;
